import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const Background: React.FC = () => {
  const ref = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    const svg = d3.select(ref.current);

    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;

    // オフセットを計算（ウィンドウサイズの20%）
    let offsetX = windowWidth * 0.2;
    let offsetY = windowHeight * 0.2;

    // 新しいSVGのサイズを設定
    let width = windowWidth + offsetX * 2;
    let height = windowHeight + offsetY * 2;

    // SVGのサイズと位置を更新
    svg
      .attr("width", width)
      .attr("height", height)
      .style("position", "fixed")
      .style("top", `-${offsetY}px`)
      .style("left", `-${offsetX}px`)
      .style("z-index", -1);

    // フローラインを生成する関数
    const renderFlowLines = () => {
      svg.selectAll("*").remove(); // 既存のコンテンツをクリア

      const numLines = 50; // ラインの数
      const lineData = d3.range(numLines).map((d) => {
        const y = Math.random() * height;
        const amplitude = Math.random() * 50 + 20; // 振幅
        const frequency = Math.random() * 0.005 + 0.002; // 周波数
        const phase = Math.random() * Math.PI * 2; // 位相
        const points = d3.range(0, width + 100, 10).map((x) => {
          return [x, y + amplitude * Math.sin(frequency * x + phase)] as [
            number,
            number
          ];
        });
        return points;
      });

      const colors = d3
        .scaleLinear<string>()
        .domain([0, numLines])
        .range(["#ffffff", "#4AB1CC"]); // 基調色を '#4AB1CC' に設定

      // パスを描画
      svg
        .selectAll("path")
        .data(lineData)
        .enter()
        .append("path")
        .attr("d", d3.line())
        .attr("stroke", (d, i) => colors(i))
        .attr("stroke-width", 2)
        .attr("fill", "none")
        .attr("opacity", 0.6)
        .attr("stroke-linecap", "round")
        .attr("stroke-linejoin", "round");
    };

    renderFlowLines();

    // リサイズ時の処理
    const handleResize = () => {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;

      // オフセットと新しいSVGのサイズを再計算
      offsetX = windowWidth * 0.2;
      offsetY = windowHeight * 0.2;
      width = windowWidth + offsetX * 2;
      height = windowHeight + offsetY * 2;

      // SVGのサイズと位置を更新
      svg
        .attr("width", width)
        .attr("height", height)
        .style("top", `-${offsetY}px`)
        .style("left", `-${offsetX}px`);

      // フローラインを再描画
      renderFlowLines();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <svg ref={ref} />;
};

export default Background;
